/* Extracted from the inline <script> in snippets/pc-ai-searchbar.liquid so browsers can cache it; loaded with defer. */
(function () {
  'use strict';

  var API_URL = 'https://shopify.partcatalog.com/search.php';
  var RL_KEY = 'pc_ai_rl';
  var MIN_GAP_MS = 2000;
  var MAX_PER_MIN = 8;
  var HINTS = [
    'In your own words, what are you looking for?',
    'brake pads for my 2012 Honda Civic',
    'wiper blades for a 2016 Accord',
    '19230-RMX-004',
    'floor mats for my 2022 Tacoma',
    'the belt that squeals when I start my truck'
  ];

  function init() {
    var widget = document.getElementById('pc-ai-header');
    var slot = document.getElementById('pcai-header-slot');
    var header = document.getElementById('site-header');
    if (!widget || !slot || !header) { return; }

    /* ---- Header mount guard ---- */
    /* The widget is rendered inside the slot by pc-topnav.liquid; this only
       moves it if some other render path put it elsewhere. */
    if (widget.parentNode !== slot) { slot.appendChild(widget); }
    widget.hidden = false;

    var form    = widget.querySelector('form');
    var input   = widget.querySelector('.pcai-input');
    var goBtn   = widget.querySelector('.pcai-go');
    var panel   = widget.querySelector('.pcai-panel');
    var status  = widget.querySelector('.pcai-status');
    var actions = widget.querySelector('.pcai-actions');
    var links   = widget.querySelector('.pcai-links');
    var recent     = widget.querySelector('.pcai-recent');
    var recentRow  = widget.querySelector('.pcai-recent__row');
    var recentPrev = widget.querySelector('.pcai-recent__nav--prev');
    var recentNext = widget.querySelector('.pcai-recent__nav--next');
    var recentLive = widget.querySelector('.pcai-recent-live');
    var searches   = widget.querySelector('.pcai-searches');
    var searchList = widget.querySelector('.pcai-searches__list');

    // showVehiclePrompt() repurposes the placeholder ("e.g. brake pads");
    // defaultPlaceholder is what resetPanel() always restores. It's also
    // width-aware: the full markup placeholder clips mid-word below
    // NARROW_BP, so under that width we swap in a shorter string. Updated
    // once at boot and again (debounced) on resize so resetPanel()'s
    // notion of "default" always matches the current width.
    var NARROW_BP = 900;
    var FULL_PLACEHOLDER = input.placeholder;
    var SHORT_PLACEHOLDER = 'Part #, brand, vehicle or VIN';
    function widthPlaceholder() {
      return window.innerWidth < NARROW_BP ? SHORT_PLACEHOLDER : FULL_PLACEHOLDER;
    }
    var defaultPlaceholder = widthPlaceholder();
    input.placeholder = defaultPlaceholder;

    // Re-check on resize (debounced): update defaultPlaceholder's notion of
    // "current width" so resetPanel() restores the right string, and
    // refresh the live field only when it's idle at the default (panel
    // closed, nothing typed) - never stomp typed text or the
    // showVehiclePrompt() "e.g. brake pads" override, which only appears
    // while the panel is open.
    var placeholderResizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(placeholderResizeTimer);
      placeholderResizeTimer = window.setTimeout(function () {
        var next = widthPlaceholder();
        if (next === defaultPlaceholder) { return; }
        defaultPlaceholder = next;
        if (!input.value && panel.hidden) { input.placeholder = defaultPlaceholder; }
      }, 150);
    }, { passive: true });

    var inFlight = false;
    var lastSubmit = 0;
    var hintIdx = 0;

    var PAGE_TYPE = widget.getAttribute('data-page-type') || 'other';
    var ctxVehicle = null;   // vehicle context for follow-up searches (from a VIN or a vehicle-only search)
    var ctxFromVin = false;  // whether ctxVehicle came from a VIN (for the log flag)

    /* ---- VIN detection (same validation as /pages/vin-decoder: 17 chars,
       no I/O/Q, NHTSA check digit for North American VINs) ---- */
    var VIN_TRANSLIT = { A:1, B:2, C:3, D:4, E:5, F:6, G:7, H:8, J:1, K:2, L:3,
                         M:4, N:5, P:7, R:9, S:2, T:3, U:4, V:5, W:6, X:7, Y:8, Z:9 };
    var VIN_WEIGHTS = [8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2];
    function isValidVin(v) {
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(v)) { return false; }
      if (/^[145]/.test(v)) {
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          var c = v.charAt(i);
          var n = /\d/.test(c) ? parseInt(c, 10) : VIN_TRANSLIT[c];
          if (n === undefined) { return false; }
          sum += n * VIN_WEIGHTS[i];
        }
        var rem = sum % 11;
        if (v.charAt(8) !== (rem === 10 ? 'X' : String(rem))) { return false; }
      }
      return true;
    }
    /* Returns {vin, rest} for a valid VIN token, {invalid: true} for a
       VIN-shaped token that fails validation (mistyped - the decoder page
       explains exactly what is wrong), else null. */
    function extractVin(q) {
      var tokens = q.split(/\s+/);
      var invalid = false;
      for (var i = 0; i < tokens.length; i++) {
        var t = tokens[i].toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (t.length !== 17) { continue; }
        if (isValidVin(t)) {
          return { vin: t, rest: tokens.slice(0, i).concat(tokens.slice(i + 1)).join(' ').trim() };
        }
        invalid = t;
      }
      return invalid ? { invalid: true, vin: invalid } : null;
    }

    /* Same garage persistence contract as fitment-checker.js / the VIN page */
    function persistVehicle(v) {
      try {
        window.localStorage.setItem('ymm_selection', JSON.stringify(v));
        window.localStorage.setItem('pc_ymm_v1', JSON.stringify(v));
        document.cookie = 'ymm=' + encodeURIComponent(JSON.stringify(v)) + ';path=/;max-age=' + (60 * 60 * 24 * 180);
        document.cookie = 'pc_ymm=' + encodeURIComponent(JSON.stringify(v)) + ';path=/;max-age=' + (60 * 60 * 24 * 30) + ';SameSite=Lax';
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('vehicle:changed', { detail: v })); } catch (e) {}
    }

    function track(name, props) {
      try {
        if (!(window.Relay && window.Relay.track)) { return; }
        var p = props || {};
        p.page_type = PAGE_TYPE;   // per-surface sub-analysis on the Relay dashboard
        p.placement = 'header';    // distinguishes from the earlier bottom-bar data
        window.Relay.track(name, p);
      } catch (e) {}
    }

    function sessionId() {
      try { return window.sessionStorage.getItem('relay_sid') || ''; } catch (e) { return ''; }
    }

    /* ---- Rotating placeholder hints (pause while the shopper types) ----
       G1: disabled - mockup calls for a static "Part number, brand or keyword"
       placeholder (set on the input above) instead of rotating marketing
       examples. Uncomment the setInterval call below to restore rotation. */
    /*
    window.setInterval(function () {
      if (document.activeElement === input || input.value) { return; }
      hintIdx = (hintIdx + 1) % HINTS.length;
      input.placeholder = HINTS[hintIdx];
    }, 4000);
    */

    /* ---- Panel state helpers (DOM built via createElement - no innerHTML
       with data, even though every value is server-built) ---- */
    function resetPanel() {
      panel.hidden = true;
      status.textContent = '';
      actions.hidden = true; actions.textContent = '';
      links.hidden = true; links.textContent = '';
      if (recent) { recent.hidden = true; }
      if (searches) { searches.hidden = true; }
      idleOpen = false;
      input.placeholder = defaultPlaceholder;
    }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) { n.className = cls; }
      if (text != null) { n.textContent = text; }
      return n;
    }
    function btn(label, cls, onClick) {
      var b = el('button', 'pcai-btn' + (cls ? ' ' + cls : ''), label);
      b.type = 'button';
      b.addEventListener('click', onClick);
      return b;
    }

    /* ---- Client-side rate limiting (backend enforces 20/min/IP with 429) ---- */
    function rateLimited() {
      var now = Date.now();
      if (inFlight || now - lastSubmit < MIN_GAP_MS) { return true; }
      var ts = [];
      try { ts = JSON.parse(window.sessionStorage.getItem(RL_KEY)) || []; } catch (e) {}
      ts = ts.filter(function (t) { return now - t < 60000; });
      if (ts.length >= MAX_PER_MIN) { return true; }
      ts.push(now);
      try { window.sessionStorage.setItem(RL_KEY, JSON.stringify(ts)); } catch (e) {}
      return false;
    }

    /* ---- Result rendering ---- */
    function matchLabel(data) {
      // The brand page itself, or a named brand's directory when nothing
      // inside the brand matched.
      if (data.brand_label && (data.action === 'brand' || data.action === 'browse' || data.action === 'keyword')) {
        return data.brand_label + ' parts';
      }
      if (data.action === 'product' && data.products && data.products.length) {
        return 'part ' + data.products[0].part;
      }
      if (data.collections && data.collections.length) {
        return data.collections[0].subcategory;
      }
      if (data.action === 'vehicle' && data.vehicle && data.vehicle.make) {
        return 'your ' + [data.vehicle.year, data.vehicle.make, data.vehicle.model]
          .filter(Boolean).join(' ') + ' catalog';
      }
      return 'your results';
    }

    // Shopify's own keyword search page. The search bar never sends anyone
    // there: the API no longer returns it, and this guard holds even if an
    // older API build or a cached response still does.
    // Audit TH-4: the redirect target comes from the search backend (and the
    // model behind it). Only a same-site destination is ever followed. The
    // API returns absolute https://www.partcatalog.com/... URLs, so those are
    // reduced to their path; a bare path is taken as is; anything else (other
    // hosts, "//host", backslash tricks, javascript:) is refused. Returns the
    // same-origin path to navigate to, or null.
    var SITE_HOSTS = ['www.partcatalog.com', 'partcatalog.com'];
    function sitePath(u) {
      if (typeof u !== 'string' || !u) { return null; }
      if (/^\/(?![\/\\])/.test(u)) { return u; }
      try {
        var p = new URL(u);
        var host = p.hostname.toLowerCase();
        if (p.protocol !== 'https:') { return null; }
        if (host !== window.location.hostname.toLowerCase() && SITE_HOSTS.indexOf(host) === -1) { return null; }
        return p.pathname + p.search + p.hash;
      } catch (e) { return null; }
    }
    function isSafePath(u) { return sitePath(u) !== null; }

    function isShopifySearchUrl(url) {
      try {
        var path = new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
        return path === '/search' || /\/search$/.test(path);
      } catch (e) { return true; }
    }

    // Confident match: skip the intermediate panel entirely and navigate
    // right away. The status line (existing aria-live region) just narrates
    // the redirect in flight so the panel isn't sitting dead during page load.
    function redirectToMatch(data) {
      var dest = sitePath(data.redirect_url);
      if (dest === null) { return; }
      var label = matchLabel(data);
      showSearching('Taking you to ' + label + '…');
      track('search_redirect', { mode: 'auto', action: data.action });
      window.location.assign(dest);
    }

    function showSorry() {
      resetPanel();
      panel.hidden = false;
      status.textContent = 'Sorry, no matches.';
      var hint = el('div', 'pcai-hint');
      hint.appendChild(document.createTextNode('Try something like '));
      hint.appendChild(el('em', null, '‘brake pads for my 2012 Honda Civic’'));
      status.appendChild(hint);
      actions.hidden = false;
      var tryAgain = btn('Try Again', 'pcai-btn--primary', function () {
        resetPanel();
        input.value = '';
        input.focus();
      });
      actions.appendChild(tryAgain);
      showRecentBelowMessage();   // a way back to parts they already found
      tryAgain.focus();
    }

    // Our search API failed, timed out or is switched off for the day. Said
    // in place: there is no keyword-search page to fall back to. The query
    // stays in the field so Try Again only needs Enter.
    function showTrouble() {
      resetPanel();
      panel.hidden = false;
      status.textContent = 'Search is having trouble right now.';
      status.appendChild(el('div', 'pcai-hint', 'Please try again in a moment.'));
      actions.hidden = false;
      var tryAgain = btn('Try Again', 'pcai-btn--primary', function () {
        resetPanel();
        input.focus();
        input.select();
      });
      actions.appendChild(tryAgain);
      showRecentBelowMessage();
      tryAgain.focus();
    }

    function showNotice(text) {
      resetPanel();
      panel.hidden = false;
      status.textContent = text;
    }

    /* ---- Submit (VIN-aware) ---- */
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var q = input.value.trim();
      if (!q || rateLimited()) { return; }
      lastSubmit = Date.now();
      recordSearch(q);

      var vinX = extractVin(q);
      if (vinX && vinX.invalid) { vinFallback(vinX.vin); return; }
      if (vinX) { decodeVin(vinX.vin, vinX.rest); return; }
      doSearch(q, false);
    });

    function showSearching(text) {
      resetPanel();
      panel.hidden = false;
      status.textContent = '';
      status.appendChild(el('span', 'pcai-spin'));
      status.appendChild(document.createTextNode(' ' + text));
    }

    /* ---- VIN: decode client-side via NHTSA (same API as /pages/vin-decoder),
       then canonicalize through our search API. The VIN itself never leaves
       the browser toward our servers. ---- */
    function decodeVin(vin, rest) {
      lastVin = vin;
      inFlight = true;
      goBtn.disabled = true;
      showSearching('Decoding your VIN…');
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var timer = window.setTimeout(function () { if (ctrl) { ctrl.abort(); } }, 3000);
      fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/'
            + encodeURIComponent(vin) + '?format=json',
            { signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          window.clearTimeout(timer);
          var row = data && data.Results && data.Results[0];
          var year = row ? parseInt(row.ModelYear, 10) : NaN;
          if (!row || !row.Make || !year) { vinFallback(vin); return; }
          track('vin_decoded', { year: year, make: row.Make });
          ctxVehicle = { year: year, make: row.Make, model: row.Model || '' };
          ctxFromVin = true;
          inFlight = false;
          goBtn.disabled = false;
          doSearch(rest, true);
        })
        .catch(function () { window.clearTimeout(timer); vinFallback(vin); });
    }

    /* Decode failed: the existing VIN decoder page is the safety net; its
       ?vin= deep-link auto-populates the form and runs the decode. */
    var lastVin = null;
    function vinFallback(vin) {
      track('search_miss', { reason: 'vin_decode_failed' });
      var v = vin || lastVin;
      window.location.assign('/pages/vin-decoder' + (v ? '?vin=' + encodeURIComponent(v) : ''));
    }

    /* Vehicle identified (VIN or vehicle-only search), garage set: ask the second question */
    function showVehiclePrompt() {
      resetPanel();
      panel.hidden = false;
      var label = ctxVehicle
        ? [ctxVehicle.year, ctxVehicle.make, ctxVehicle.model].filter(Boolean).join(' ')
        : 'your vehicle';
      status.textContent = '';
      status.appendChild(el('strong', null, '✓ Found your ' + label + '!'));
      status.appendChild(document.createTextNode(' Now — what are you looking for?'));
      var hint = el('div', 'pcai-hint');
      hint.appendChild(document.createTextNode('Try '));
      hint.appendChild(el('em', null, '‘brake pads’, ‘wiper blades’, ‘floor mats’…'));
      status.appendChild(hint);
      input.value = '';
      input.placeholder = 'e.g. brake pads';
      input.focus();
    }

    function doSearch(q, fromVin) {
      inFlight = true;
      goBtn.disabled = true;
      showSearching(q ? 'Searching…' : 'Looking up your vehicle…');

      var body = { q: q, session_id: sessionId() };
      if (ctxVehicle) { body.vehicle = ctxVehicle; body.vin = ctxFromVin; }

      var t0 = Date.now();
      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) {
        if (r.status === 429) { return { __rl: true }; }
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        inFlight = false;
        goBtn.disabled = false;

        if (data && data.__rl) {
          showNotice('One second — please try again in a moment.');
          return;
        }
        if (!data || !data.ok) {
          // Degraded mode: say so in place (never Shopify's search page).
          if (q) {
            track('search_miss', { reason: 'api_error' });
            showTrouble();
          } else {
            vinFallback();
          }
          return;
        }

        // VIN flows: adopt the canonical ACES vehicle and set the garage
        if (fromVin && data.vehicle && data.vehicle.year && data.vehicle.make && data.vehicle.model) {
          ctxVehicle = { year: data.vehicle.year, make: data.vehicle.make, model: data.vehicle.model };
          persistVehicle(ctxVehicle);
        }
        if (fromVin && !q) { showVehiclePrompt(); return; }

        track('search', {
          q_len: q.length,
          action: data.action,
          intent: data.intent || '',
          confidence: data.confidence || '',
          latency_ms: Date.now() - t0,
          vin: fromVin || !!ctxVehicle,
          base_vehicle_id: (data.vehicle && data.vehicle.base_vehicle_id) || 0
        });

        var canRedirect = isSafePath(data.redirect_url) && !isShopifySearchUrl(data.redirect_url);

        if (data.action === 'vehicle' && data.vehicle
            && data.vehicle.year && data.vehicle.make && data.vehicle.model) {
          ctxVehicle = { year: data.vehicle.year, make: data.vehicle.make, model: data.vehicle.model };
          persistVehicle(ctxVehicle);
          // A brand was named too ("dorman 2012 honda civic"): go to that
          // brand's parts for the vehicle.
          if (data.brand && canRedirect) { redirectToMatch(data); return; }
          // "2019 Infiniti Q30" and friends: set the garage and ask what they
          // need, instead of bouncing them to the homepage.
          showVehiclePrompt();
          return;
        }

        if (data.unavailable) {
          // The API could not classify anything right now (model error,
          // daily spend cap…): not the same as "no matches".
          track('search_miss', { reason: data.reason || 'unavailable' });
          showTrouble();
        } else if (data.action === 'browse' && !(data.brand && canRedirect)) {
          track('search_miss', { reason: data.reason || data.intent || 'no_match' });
          showSorry();
        } else if (canRedirect) {
          // Includes a named brand with nothing matched inside it: "browse"
          // then points at that brand's own directory.
          if (data.action === 'keyword' || data.action === 'browse') {
            track('search_miss', { reason: data.reason || data.intent || 'no_match' });
          }
          redirectToMatch(data);
        } else {
          track('search_miss', { reason: data.reason || 'no_destination' });
          showSorry();
        }
      })
      .catch(function () {
        inFlight = false;
        goBtn.disabled = false;
        if (q) {
          track('search_miss', { reason: 'network_error' });
          showTrouble();
        } else {
          vinFallback();
        }
      });
    }

    /* ---- Dropdown etiquette: Escape or clicking outside closes the panel.
       Bound at the widget root (not just the input) so Escape works from anywhere focus
       has landed inside the open panel - guarded by !panel.hidden so it's a
       no-op once the panel is already closed, preserving the prior
       input-only behavior in that state. Also checks e.defaultPrevented, the
       same guard used by the guarantee modal's document-level Escape
       listener, in case a nested widget (e.g. a .pc-fdd searchable dropdown)
       already consumed this Escape to close just itself. ---- */
    widget.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !panel.hidden && !ev.defaultPrevented) { resetPanel(); }
    });
    // "Inside" is judged from the event's path, captured at dispatch time,
    // not from where the target sits now: a control that removes itself on
    // click (a recent search's × button) is already detached by the time
    // the click bubbles here, and widget.contains() would call it outside.
    document.addEventListener('click', function (ev) {
      if (panel.hidden) { return; }
      var path = ev.composedPath ? ev.composedPath() : null;
      var inside = path ? path.indexOf(widget) !== -1 : widget.contains(ev.target);
      if (!inside) { resetPanel(); }
    });

    /* ---- Idle dropdown: recently viewed + recent searches ----
       Focusing the empty search field opens the dropdown with two lists
       that live only in this browser (localStorage):
         - "Pick up where you left off": the parts this shopper last viewed,
           as a row of thumbnails captioned with the product title. Product
           pages emit a #pc-recent-product JSON record
           (sections/main-product-v2.liquid) and each view is pushed onto a
           short most-recent-first list. The same list feeds the
           snippets/pc-recent.liquid page blocks.
         - "Your recent searches": the last few queries submitted from this
           bar. Each one can be run again, or removed with its × button.
       The idle state only ever opens into a closed panel, so it never
       replaces a search status or the vehicle prompt. The recently-viewed
       row is also shown under the "Sorry, no matches" message. */
    var RECENT_KEY = 'pc_recent_v1';
    var RECENT_MAX = 12;
    var SEARCHES_KEY = 'pc_searches_v1';
    var SEARCHES_MAX = 6;
    var currentHandle = '';
    var idleOpen = false;   // the panel is showing the idle (focus) state

    function readRecent() {
      try {
        var list = JSON.parse(window.localStorage.getItem(RECENT_KEY));
        if (!Array.isArray(list)) { return []; }
        return list.filter(function (r) { return r && typeof r.h === 'string' && r.h; });
      } catch (e) { return []; }
    }

    function recordProductView() {
      var node = document.getElementById('pc-recent-product');
      if (!node) { return; }
      var p = null;
      try { p = JSON.parse(node.textContent); } catch (e) {}
      if (!p || typeof p.handle !== 'string' || !p.handle) { return; }
      currentHandle = p.handle;
      var list = readRecent().filter(function (r) { return r.h !== p.handle; });
      list.unshift({ h: p.handle, t: String(p.title || '').slice(0, 160), i: String(p.img || '') });
      try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) {}
    }

    function updateRecentNav() {
      var max = recentRow.scrollWidth - recentRow.clientWidth;
      recentPrev.hidden = recentRow.scrollLeft <= 2;
      recentNext.hidden = recentRow.scrollLeft >= max - 2;
    }

    // The part being viewed right now is left out: the row is for getting
    // back to the others. Returns how many thumbnails were built.
    function buildRecent() {
      var list = readRecent().filter(function (r) { return r.h !== currentHandle; });
      recentRow.textContent = '';
      list.forEach(function (r) {
        var a = el('a', 'pcai-recent__item');
        a.href = '/products/' + encodeURIComponent(r.h);
        var label = typeof r.t === 'string' && r.t ? r.t : 'Recently viewed part';
        a.title = label;
        // Thumbnail box. No photo on file, or it fails to load: say so -
        // the title below still identifies the part.
        var box = el('span', 'pcai-recent__img');
        function noPhoto() {
          box.textContent = '';
          box.appendChild(el('span', 'pcai-recent__nophoto', 'No photo'));
        }
        if (typeof r.i === 'string' && /^(https:)?\/\//.test(r.i)) {
          var img = document.createElement('img');
          img.alt = '';   // decorative: the title below carries the name
          img.width = 96; img.height = 76;
          img.onerror = noPhoto;
          img.src = r.i;
          box.appendChild(img);
        } else {
          noPhoto();
        }
        a.appendChild(box);
        a.appendChild(el('span', 'pcai-recent__title', label));
        var li = document.createElement('li');
        li.appendChild(a);
        recentRow.appendChild(li);
      });
      return list.length;
    }

    function showRecentBelowMessage() {
      if (!recent || !recentRow || !recentPrev || !recentNext) { return; }
      if (!buildRecent()) { return; }
      recent.hidden = false;
      recentRow.scrollLeft = 0;
      updateRecentNav();
    }

    function readSearches() {
      try {
        var list = JSON.parse(window.localStorage.getItem(SEARCHES_KEY));
        if (!Array.isArray(list)) { return []; }
        return list.filter(function (q) { return typeof q === 'string' && q; }).slice(0, SEARCHES_MAX);
      } catch (e) { return []; }
    }
    function writeSearches(list) {
      try { window.localStorage.setItem(SEARCHES_KEY, JSON.stringify(list.slice(0, SEARCHES_MAX))); } catch (e) {}
    }
    // Most recent first; re-running an old query moves it back to the top.
    function recordSearch(q) {
      var key = q.toLowerCase();
      var list = readSearches().filter(function (s) { return s.toLowerCase() !== key; });
      list.unshift(q);
      writeSearches(list);
    }

    function svgIcon(d) {
      var NS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('width', '16'); svg.setAttribute('height', '16');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', d);
      svg.appendChild(path);
      return svg;
    }

    function announce(text) {
      if (recentLive) { recentLive.textContent = text; }
    }

    // One row per query: a button that runs it again and a × that forgets
    // it. Returns how many rows were built.
    function buildSearches() {
      var list = readSearches();
      searchList.textContent = '';
      list.forEach(function (q) {
        var li = document.createElement('li');

        var run = el('button', 'pcai-searches__q');
        run.type = 'button';
        run.appendChild(svgIcon('M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-3.5-3.5'));
        run.appendChild(el('span', null, q));
        run.addEventListener('click', function () {
          resetPanel();
          input.value = q;
          if (form.requestSubmit) { form.requestSubmit(); }
          else { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
        });

        var rm = el('button', 'pcai-searches__x');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove “' + q + '” from your recent searches');
        rm.appendChild(svgIcon('M6 6l12 12M18 6L6 18'));
        rm.addEventListener('click', function () {
          writeSearches(readSearches().filter(function (s) { return s !== q; }));
          // Keep keyboard focus in the list: next row's ×, else the one
          // before; with nothing left, back to the field.
          var next = li.nextElementSibling || li.previousElementSibling;
          searchList.removeChild(li);
          announce('Removed “' + q + '” from your recent searches.');
          if (next) { next.querySelector('.pcai-searches__x').focus(); return; }
          searches.hidden = true;
          if (recent.hidden) { resetPanel(); }
          input.focus();
        });

        li.appendChild(run);
        li.appendChild(rm);
        searchList.appendChild(li);
      });
      return list.length;
    }

    var idleAnnounced = false;
    function showIdle() {
      if (!panel.hidden || input.value || inFlight) { return; }
      var viewed = buildRecent();
      var searched = buildSearches();
      if (!viewed && !searched) { return; }
      recent.hidden = !viewed;
      searches.hidden = !searched;
      panel.hidden = false;
      idleOpen = true;
      if (viewed) {
        recentRow.scrollLeft = 0;
        updateRecentNav();
      }
      // Screen readers get no cue that the lists appeared under the field;
      // say so once per page view (every focus would be noise).
      if (!idleAnnounced) {
        idleAnnounced = true;
        var parts = [];
        if (viewed) { parts.push(viewed + (viewed === 1 ? ' recently viewed part' : ' recently viewed parts')); }
        if (searched) { parts.push(searched + (searched === 1 ? ' recent search' : ' recent searches')); }
        announce(parts.join(' and ') + (viewed + searched === 1 ? ' is' : ' are') + ' listed after the Search button.');
      }
    }

    if (recent && recentRow && recentPrev && recentNext && searches && searchList) {
      recordProductView();

      input.addEventListener('focus', showIdle);
      input.addEventListener('click', showIdle);
      // Typing takes over the dropdown; clearing the field brings the lists back.
      input.addEventListener('input', function () {
        if (!input.value) { showIdle(); }
        else if (idleOpen) { resetPanel(); }
      });
      // Tabbing out of the widget closes the idle lists. A null
      // relatedTarget (mouse/touch on something unfocusable, e.g. a
      // thumbnail in Safari) is left to the document click handler above -
      // closing here would hide the link before its click lands.
      widget.addEventListener('focusout', function (ev) {
        if (!idleOpen || !ev.relatedTarget || widget.contains(ev.relatedTarget)) { return; }
        resetPanel();
      });

      // Escape from anything inside the panel: put focus back in the field
      // BEFORE the widget-level handler above closes the panel, so focus is
      // never left on a hidden control. (The panel is still open at this
      // point, so the field's focus handler doesn't rebuild the lists.)
      panel.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !ev.defaultPrevented) { input.focus(); }
      });

      recentRow.addEventListener('scroll', updateRecentNav, { passive: true });
      [[recentPrev, -1], [recentNext, 1]].forEach(function (pair) {
        // Keep focus (and the mobile keyboard) in the search field.
        pair[0].addEventListener('mousedown', function (ev) { ev.preventDefault(); });
        pair[0].addEventListener('click', function () {
          recentRow.scrollLeft += pair[1] * Math.max(160, recentRow.clientWidth - 80);
        });
      });
    }

    /* ---- A search submitted before this script loaded ----
       The form's inline onsubmit (snippets/pc-ai-searchbar.liquid) holds an
       early Enter instead of letting the browser post it to Shopify's
       /search page, and flags it. Now that the real handler is wired, drop
       the inline guard and run that search. */
    form.onsubmit = null;
    if (form.getAttribute('data-pending') === '1') {
      form.removeAttribute('data-pending');
      if (input.value.trim()) {
        if (form.requestSubmit) { form.requestSubmit(); }
        else { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
      }
    }

    /* ---- Funnel instrumentation: impression + first-focus (intent) ---- */
    var focusTracked = false;
    input.addEventListener('focus', function () {
      if (focusTracked) { return; }
      focusTracked = true;
      track('search_bar_focused', {});
    });
    track('search_bar_shown', { state: 'open' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
